import React from "react";
import Container from "../@FreeModel/Container/Container";
import {Button, Text, Title} from "../@FreeModel";
import Footer from "./Footer";
import {FmComponent} from "../@FreeModel/types/types";

// @ts-ignore
const homeURL = window.state?.homeURL ?? 'https://home.dev.freemodel.com'

interface INotice extends FmComponent {
  title: string;
  message: string;
}

const Notice = ({title, message}: INotice): React.ReactElement => {
  return <Container className="landing-page">
    <Title size="xl-xxl" weight="semibold" lineHeight="lg">{title}</Title>

    <br/>

    <Text>{message}</Text>

    <br/>
    <br/>

    <Button onClick={() => document.location = homeURL}>Continue</Button>

    <br/>
    <br/>

    <Footer/>

  </Container>
}

export default Notice;
